import { Observable, of } from 'rxjs'
import { filter, map, switchMap, take, tap } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, Input, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'

import { Sale } from '../sale'
import { saleActions } from '../sale.actions'
import { saleSelectors } from '../sale.selectors'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { NotificationService } from 'src/app/core/notification.service'
import { SaleService } from '../sale.service'
import { documentSelectors } from '../../document/document.selectors'
import { Dictionary } from '@ngrx/entity'
import { Document } from '../../document/document'
import { environment } from 'src/environments/environment'
import { BulkAction, BulkActionEvent } from 'src/app/shared/interfaces'
import { AccessRights } from '../../role/user-role/user-role'
import { UserAccessRightService } from 'src/app/shared/services/user-access-rights.service'

@Component({
  selector: 'sale-documents-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class SaleDocumentsTabComponent implements OnInit {
  @Input() public saleId: number
  public accessRights = AccessRights
  public saleId$: Observable<number>
  public sale$: Observable<Sale>
  public documentEntities$: Observable<Dictionary<Document>>
  public documents$: Observable<Document[]>
  public staticAssetBaseUrl: string = environment.staticAssetBaseUrl

  public BulkAction = BulkAction

  constructor(
    private store: Store<AppState>,
    private userAccessRightService: UserAccessRightService,
    private notificationService: NotificationService,
    private saleService: SaleService
  ) {}

  ngOnInit() {
    this.saleId$ = this.saleId
      ? of(this.saleId)
      : this.store
          .select(saleSelectors.selectIdRouteParam)
          .pipe(filter((id) => Boolean(id)))

    this.documentEntities$ = this.store.select(documentSelectors.selectEntities)

    this.sale$ = this.saleId$.pipe(
      tap((id) =>
        this.store.dispatch(
          saleActions.fetchOneById({
            id,
            params: RequestQueryBuilder.create({
              join: [
                { field: 'creditSales' },
                { field: 'tags' },
                { field: 'documents' }
              ]
            })
          })
        )
      ),
      switchMap((saleId) => this.store.select(saleSelectors.selectById, saleId))
    )

    this.documents$ = this.sale$.pipe(
      filter((p) => Boolean(p)),
      switchMap((sale) =>
        this.store
          .select(documentSelectors.selectAll)
          .pipe(
            map((documents) =>
              documents.filter((document) =>
                sale?.documents?.includes(document.id)
              )
            )
          )
      )
    )
  }

  public onSubmitImage(file: File) {
    this.userAccessRightService
      .isAllowedByAccessRight([this.accessRights.Sales_write])
      .pipe(take(1))
      .subscribe((canAccess) => {
        if (!canAccess) {
          return
        } else {
          this.saleId$
            .pipe(take(1))
            .subscribe((saleId) =>
              this.saleService.saveOneWithFile(saleId, file)
            )
        }
      })
  }

  public onBulkAction(bulkActionEvent: BulkActionEvent) {
    if (bulkActionEvent.action == BulkAction.DELETE) {
      this.saleId$.pipe(take(1)).subscribe((saleId) => {
        bulkActionEvent.items.forEach((item) =>
          this.saleService.deleteOneWithFile(saleId, item.id)
        )
      })
    }
  }
}
